import { Input as InputPrimitive } from "@base-ui/react/input";
import type * as React from "react";

import { cn } from "../cn";
import { FIELD_FOCUS } from "./focus-ring";

// Design spec §6.8: 36 px, 13 px (16 px below 768 so iOS does not zoom), white field with a
// hairline shadow; hover darkens the border, focus turns it --ring with a 2 px ring.
function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        `h-9 w-full min-w-0 rounded-md border border-input bg-card px-3 py-1 text-sm text-foreground shadow-sm transition-[color,border-color,box-shadow] duration-(--dur-fast) file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-ui file:text-foreground placeholder:text-muted-foreground hover:border-strong ${FIELD_FOCUS} disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-55 aria-invalid:border-destructive aria-invalid:focus-visible:ring-destructive max-md:text-md`,
        className,
      )}
      {...props}
    />
  );
}

export { Input };
